import React, {  Component } from 'react';
import { connect } from 'react-redux';

class ReturnGreaterThan15OverlayDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDialog: false
        }
    }
	componentDidMount() {
		// window.scrollTo(0, 0);
		this.setState({
            showDialog: this.props.showDialog
        });
	}
    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
		this.props.handleDialog && this.props.handleDialog('ReturnGreaterThan15OverlayDialog');
    }
    render() {
        return (
			<div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="confirmReleaseYesNoOverlayDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
					<a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">Request Return</h2>
                    <p>If you need to return the qty you entered please <a href="" onClick={this.props.handleClickHere}>click here</a> as this request will require special handling.</p>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
   return {state};
};

ReturnGreaterThan15OverlayDialog = connect(mapStateToProps)(ReturnGreaterThan15OverlayDialog);
export default ReturnGreaterThan15OverlayDialog;



// WEBPACK FOOTER //
// ./src/App/components/dialogs/returnGreaterThan15OverlayDialog.js